import styled from 'styled-components'
import { position } from 'styled-system'
import { Box } from 'reflexbox/styled-components'

export const Container = styled(Box)`
  width: fit-content;

  ${position}
`
